import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  HiddenVisually,
  Stack,
} from 'braid-design-system';
import { memo } from 'react';

import { useHotjarEvent } from 'src/hooks/useHotjarEvent';
import {
  useIsHomepageGenAIChatAltModelEnabled,
  useIsHomepageGenAIChatEnabled,
} from 'src/store/featureFlags/hooks';
import { useSavedRecentSearchesFeatureFlag } from 'src/store/featureFlags/useSavedRecentSearchesFeatureFlag';

import translations from './.vocab';
import { CareerFeedAIAssistantV2 } from './CareerFeedAIAssistant/CareerFeedAIAssistantV2';
import { CareerFeedAIAssistantProvider } from './CareerFeedAIAssistant/hooks/useCareerFeedAIAssistant';
import { MoreRecommendations } from './DashboardRecommendations/MoreRecommendations';
import { TopRecommendations } from './DashboardRecommendations/TopRecommendations';
import SavedSearches from './DashboardSaveSearches/SavedSearches';
import SavedJobs from './DashboardSavedJobs/SavedJobs';
import { MyActivityTiles } from './MyActivityTiles/MyActivityTiles';
import { JobDetailsViewDrawer } from './SharedComponent/JobDetailsViewDrawer/JobDetailsViewDrawer';
import { SignedInDashboardContextProvider } from './SignedInDashboardContextProvider';

const SignedInDashboard = () => {
  const { t } = useTranslations(translations);
  const isHomepageGenAIChatEnabled = useIsHomepageGenAIChatEnabled();
  const isHomepageGenAIChatAltModelEnabled =
    useIsHomepageGenAIChatAltModelEnabled();

  useHotjarEvent('homepage_layout_refresh_experiment');
  const isSavedRecentSearches = useSavedRecentSearchesFeatureFlag();

  return (
    <SignedInDashboardContextProvider>
      <CareerFeedAIAssistantProvider
        useAltModel={isHomepageGenAIChatAltModelEnabled}
      >
        <HiddenVisually>
          <h1>{t('Dashboard')}</h1>
        </HiddenVisually>

        <Columns space="xlarge">
          <Column>
            <Stack space="medium">
              {!isSavedRecentSearches && <MyActivityTiles />}
              {isHomepageGenAIChatEnabled && (
                <Box
                  display={{ mobile: 'block', tablet: 'flex', desktop: 'none' }}
                >
                  <CareerFeedAIAssistantV2 />
                </Box>
              )}
              <Stack space="xsmall">
                <TopRecommendations />
                <MoreRecommendations />
              </Stack>
            </Stack>
          </Column>
          <Column width="2/5" hideBelow="desktop">
            <Stack space="large">
              {isHomepageGenAIChatEnabled && <CareerFeedAIAssistantV2 />}
              {!isSavedRecentSearches && <SavedSearches />}
              <SavedJobs />
            </Stack>
          </Column>
        </Columns>
        <JobDetailsViewDrawer />
      </CareerFeedAIAssistantProvider>
    </SignedInDashboardContextProvider>
  );
};

export default memo(SignedInDashboard);
